export const mapResponse400 = (): null => {
  return null;
};
